import React from "react";

import Navbar from "../../components/Navbar";
import Sidebar from "../../components/Sidebar";
import { PROD_LINK, STAGING_LINK } from "../../constant";
import { IS_STAGING } from "../../constant/api";
import { useAuth } from "../../context/auth-context";

/** Nav id for the Surveys rail entry; see NAV in components/Sidebar.tsx. */
export const SURVEYS_NAV_STATUS = 14;

type Props = {
  children: React.ReactNode;
};

/**
 * Standard admin page chrome (env banner → sidebar → navbar → centered content).
 *
 * The section has three routes that all need it, so it lives here rather than being
 * copy-pasted per page as the older sections do.
 */
const SurveyPageShell: React.FC<Props> = ({ children }) => {
  const { setActiveStatus } = useAuth();

  // The sidebar highlights from a status set on click, so a deep link or a browser
  // back into a survey page would otherwise leave the rail highlighting nothing.
  React.useEffect(() => {
    setActiveStatus(SURVEYS_NAV_STATUS);
  }, [setActiveStatus]);

  return (
    <div className="flex h-screen w-full flex-col overflow-hidden">
      <div className="flex h-[31px] w-full shrink-0 items-center justify-center bg-[#1B1B1B]">
        {IS_STAGING ? (
          <h4 className="text-[12px] font-medium text-[#AEBCC6]">
            You are in Staging:{" "}
            <a href={PROD_LINK} className="text-[#03C668]">
              Switch to Prod
            </a>
          </h4>
        ) : (
          <h4 className="text-[12px] font-medium text-[#AEBCC6]">
            You are in PROD:{" "}
            <a href={STAGING_LINK} className="text-[#DF4E4E]">
              Switch to Staging
            </a>
          </h4>
        )}
      </div>

      <div className="flex min-h-0 w-full flex-1 flex-col overflow-hidden lgss:flex-row">
        <Sidebar />
        <div className="flex min-h-0 min-w-0 flex-1 flex-col overflow-y-auto bg-[#13181B] lgss:w-10/12">
          <Navbar />
          <div className="mx-auto w-full max-w-[1600px] flex-1 px-5 pb-24 pt-6 font-manrope mds:px-8 lgss:px-10">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SurveyPageShell;
